function envIsTruthy(raw: string | undefined): boolean {
  if (raw === undefined || raw === '') return false
  return ['1', 'true', 'yes', 'on'].includes(raw.trim().toLowerCase())
}

/**
 * When true, Quality Control tab + SiteView QUALITY create/hydrate are available.
 * Set at **build time** in `.env`: `REACT_APP_QUALITY_FEATURES=1`
 * (Create React App only exposes `REACT_APP_*` to the browser bundle.)
 * Staging/dev: on. Production/beta: off until ready for prod launch.
 */
export const areQualityFeaturesEnabled = envIsTruthy(
  process.env.REACT_APP_QUALITY_FEATURES,
)
